module.exports = __webpack_public_path__ + "img/TERMINATION_SCHEDULE.png";